import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = ['shutdownReasons'];

const shutdownReasonsQuery = async () => {
  return await request.get(
    `/Alert/reasons`,
    {},
    `При загрузке причин отключения произошла ошибка`
  );
};

export const useShutdownReasons = (options) =>
  useQuery(key, shutdownReasonsQuery, options);
